import secret from "../../secret.json";
import { readSessionFromUrl } from "../leveltest/session";

// 학생 홈의 아이 상태(api/assignment/student_home.py). 오늘 학원에서 · 단어 시험 · 약한 곳 · 풀이 사진 보너스.
// 공용 apiClient 는 실패하면 '오류가 발생했습니다' 창을 띄운다. 이 칸은 못 받아도 홈이 그대로 떠야 해서 fetch 로 부른다.
export const fetchHomeSummary = async () => {
  const identity = readSessionFromUrl();
  if (!identity) return null;
  const query = new URLSearchParams({ student_id: identity.studentId, random_code: identity.randomCode });
  const response = await fetch(
    `${secret.API_BASE_URL.replace(/\/+$/, "")}/api/v1/assignment/student/home-summary?${query}`
  );
  if (!response.ok) return null;
  return response.json();
};
